import React from 'react'
import './footer.css'

import { AiFillGithub, AiFillLinkedin, AiOutlineMail } from 'react-icons/ai';
import { FaSquareXTwitter } from "react-icons/fa6";
const Footer = () => {
  return (
    <footer className='footer'>
        <div className='footerContainer'>
          <div className='footerLeft'>
            <div className='signatur'>
              <span>@2024</span>
              <span>Version 1.01</span>
            </div>
          </div>
          <div className='footerRight'>
            <div className='footerIconSocialMedia'>
                  <a href="https://github.com/behzadtabari" target="_blank" rel="noopener noreferrer" aria-label="Github">
                    <AiFillGithub className="footerSocialIcon" />
                  </a>
                  <a href="https://www.linkedin.com/in/behzadtabari/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <AiFillLinkedin className="footerSocialIcon" />
                  </a>
                  <a href="mailto:behzadtabari.bt@gmail.com" aria-label="Email">
                    <AiOutlineMail className="footerSocialIcon" />
                  </a>
                  <a href="https://x.com/behzadtabari_bt" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FaSquareXTwitter className="footerSocialIcon" />
                </a>
              </div>
          </div>
        </div>
          <div className='footerLastQoute'>
          <qoute>“Enframing blocks the shining-forth of Being”</qoute>
            <span>Martin Heidegger</span>
          </div>
    </footer>
  )
}

export default Footer
